import axios from './index';

var regex = /^\d+$/;
let base = 'dashboard/communication';

class CommunicationApi {
    static List = (data) => {
        let query = '?';
        if (data.searchTerm) {
            query += `search=${data.searchTerm}&`;
        }

        if (data.channel) {
            query += `channel=${data.channel}&`;
        }

        if (data.itemsPerPage) {
            query += `limit=${data.itemsPerPage}&`;
        }

        if (data.currentPage) {
            query += `currentPage=${data.currentPage}&`;
        }

        if (data.userId) {
            query += `userId=${data.userId}&`;
        }

        return axios.get(`${base}/${query}`);
    };
}

export default CommunicationApi;
